function submitSearchForm() {
    var searchText = $("#txtSearch").val();
    searchText = $.trim(searchText);
    searchText = searchText.replace(/(<([^>]+)>)/ig, "");

    $("#txtSearch").text = searchText;

    document.getElementById("frmSearch").submit();
}


function submitSearchFormOnFacetPanel() {
    var searchText = $("#txtSearchOnFacet").val();
    searchText = $.trim(searchText);
    searchText = searchText.replace(/(<([^>]+)>)/ig, "");

    $("#txtSearchOnFacet").text = searchText;

    document.getElementById("frmSearchOnFacet").submit();
}


function submitSearchFormBlogs() {
    var searchText = $("#txtSearchBlogs").val();
    searchText = $.trim(searchText);
    searchText = searchText.replace(/(<([^>]+)>)/ig, "");

    $("#txtSearchBlogs").text = searchText;

    document.getElementById("frmBlogSearch").submit();
}


var header;
var headerHeight;

$(document).ready(function () {
    
    if ($("#heroArea").hasClass('homePage')) {
        $(".seconaryNavigation li a img").each(function () {
            var temp = $(this).attr('src').split('/');
            var newImg = temp[temp.length - 1].split(".")[0] + "light.svg";
            temp[temp.length - 1] = newImg;
            $(this).attr("src", temp.join('/'))
        })

        $(".seconaryNavigation li a").on("mouseenter", function () {
            var temp = $(this).children('img').attr('src').split('/');
            var newImg = temp[temp.length - 1].split(".")[0].replace('light', 'hover') + ".svg";
            temp[temp.length - 1] = newImg;
            $(this).children('img').attr("src", temp.join('/'));
        });

        $(".seconaryNavigation li a").on("mouseleave", function () {
            var temp = $(this).children('img').attr('src').split('/');
            var newImg = temp[temp.length - 1].split(".")[0].replace('hover', 'light') + ".svg";
            temp[temp.length - 1] = newImg;
            $(this).children('img').attr("src", temp.join('/'));
        });

    } else {
        $(".seconaryNavigation li a").on("mouseenter", function () {
            var temp = $(this).children('img').attr('src').split('/');
            var newImg = temp[temp.length - 1].split(".")[0] + "hover.svg";
            temp[temp.length - 1] = newImg;
            $(this).children('img').attr("src", temp.join('/'));
        });

        $(".seconaryNavigation li a").on("mouseleave", function () {
            var temp = $(this).children('img').attr('src').split('/');
            var newImg = temp[temp.length - 1].split(".")[0].replace('hover', '') + ".svg";
            temp[temp.length - 1] = newImg;
            $(this).children('img').attr("src", temp.join('/'));
        });
    }

    if($.cookie) {
        if ($.cookie('AirRefreshCookie') == "true") {
            $.cookie('AirRefreshCookie', 'false');
            location.reload();
        }
    }
        
    $(".notHomePage").prepend('<div id="headerOverlay" class="gradientIE9"></div>');
    $(window).scroll(function () {

        header = $(document).scrollTop();
        headerHeight = $(".subHeader").height();
        
        if (header > headerHeight) {
            $("#heroOverlay, #headerOverlay").addClass("sticky").addClass("navbar-fixed-top");
            $("#menuLine").addClass("sticky").addClass("navbar-fixed-top");

            if ($(window).width() < 750)
                $(".headerWrapper").addClass("navbar-fixed-top").addClass("stickyNav");
            else
                $(".headerContainer").addClass("navbar-fixed-top").addClass("stickyNav");

            $(".seconaryNavigation").addClass("stickySecondaryNav");
            $(".headerSearchBox, .headerSearchBox svg").css("display", "none");
            $(".searchIcon").removeClass("active");
        } else {

            $("#heroOverlay, #headerOverlay").removeClass("sticky").removeClass("navbar-fixed-top");
            $("#menuLine").removeClass("sticky").removeClass("navbar-fixed-top");

            if ($(window).width() < 750)
                $(".headerWrapper").removeClass("navbar-fixed-top").removeClass("stickyNav");
            else
                $(".headerContainer").removeClass("navbar-fixed-top").removeClass("stickyNav");

            $(".seconaryNavigation").removeClass("stickySecondaryNav");
            if ($(window).width() > 750) {
                $(".headerSearchBox, .headerSearchBox svg").css("display", "inline-block");
            }
        }

        if ($(window).width() < 750) {
            var $el = $('.menuMobile');
            var menuBottom
            if ($el.position()) {
                menuBottom = $el.position().top + $el.outerHeight(true);
            }

            var pageScrollTop = $(document).scrollTop();

            if (menuBottom < pageScrollTop && $('.menu').hasClass('cross')) {
                $(".menuIcon").toggleClass("cross");
                $(".megaMenuList").toggleClass("showMenu");
                $("ul.megaMenuList > li").each(function () {
                    $(this).removeClass("active");
                });
            }
        }
    });


    $(".dataTab ul li a").on("click", function () {
        if (!$(this).parent().hasClass("active")) {

            if ($(window).width() < 750)
                $(this).parent().addClass("active");
            else
                $(this).parent().addClass("active").siblings().removeClass("active");
        }
        else {

            if ($(window).width() < 750)
                $(this).parent().removeClass("active");
        }
    });

    //$("#contentHeader").addClass("hide");

    setTimeout(function () {
        $(".pageContent").css("padding-bottom", $(".footer").height());

        if ($(window).width() > 750 && isMobile === false) {
            $(".megaMenuList").addClass("menuDesktop");
        } else {
            $(".megaMenuList").addClass("menuMobile");
        }
    },
        500);

    /* For show Contact Us Button */

    if ($("#showContactUsRibbon").val() === "true") {

        var isPopUpOpen;

        $(".fixedContactButton").show();
        $(".contactUsContainer .popup").load("/Air/Assets/Html/ContactUs.html");
        var popUpWidth;
        $(".fixedContactButton").on("click touchstart", function (e) {
            e.stopPropagation();
            var popUpHeight = $(".contactUsContainer .popup").height();
            $(".contactUsContainer .popup").css("top", ($(window).height() - popUpHeight) / 2);
            $(this).next(".popup").animate({
                right: "0",
            }, 400);

            isPopUpOpen = true;
        });

        $(".popup").on("click", function (e) {
            e.stopPropagation();
        });

        $("body, a.closePopup").on("click touchstart", function (e) {
            popUpWidth = $(".contactUsContainer .popup").width();
            $(".popup").animate({
                right: -popUpWidth,
            }, 400);
            isPopUpOpen = false;
        });

        $(window).resize(function () {
            if (isPopUpOpen === true) {
                $(".popup").css("right", "0px");
            } else {
                $(".popup").css("right", -($(".contactUsContainer .popup").width()));
            }
        });

    } else {
        $(".fixedContactButton").hide();
    }

    /*START - Code to append "ie" class for IE browser */
    var ua = window.navigator.userAgent;
    var msie = ua.indexOf("MSIE ");

    if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./))
        $("body").addClass("ie");

    if (/Edge\/\d./i.test(navigator.userAgent)) {
        // This is Microsoft Edge
        $("body").addClass('edge');
    }

    /* END */

    setInterval(function () {
        if ($('#slider').length) {
            moveRight();
        }
    }, 3000);

    calculateWidth();

    var previousWidth = $(window).width()

    $(window).resize(function () {
        calculateWidth();
        if ($(window).width() > 750) {
            $(".filterContainer").css("display", "block");           

            $(".megaMenuList").addClass("menuDesktop");
            $(".megaMenuList").removeClass("menuMobile");
            $(".headerSearchBox, .headerSearchBox svg").css("display", "inline-block");
            $(".headerWrapper").removeClass("navbar-fixed-top").removeClass("stickyNav");

            if (header > headerHeight) {
                $(".headerContainer").addClass("navbar-fixed-top").addClass("stickyNav");
            } else {
                $(".headerContainer").removeClass("navbar-fixed-top").removeClass("stickyNav");
            }

        } else {
            if ($(".filterContainer").attr("data-open") === "yes") {
                $(".filterContainer").css("display", "block");
            } else {
                $(".filterContainer").css("display", "none");
            }

            $(".facetTitle").attr("data-status", "close");

            if ($(".facetTitle span").hasClass("triangleLeft")) {
                $(".facetTitle span").removeClass("triangleLeft").addClass("triangleRight");
            }

            $(".megaMenuList").removeClass("menuDesktop");
            $(".megaMenuList").addClass("menuMobile");
            if (previousWidth >= 750) {
                $(".headerSearchBox, .headerSearchBox svg").css("display", "none");
                $(".searchIcon").removeClass("active");
            }
        }
        $(".pageContent").css("padding-bottom", $(".footer").height());
        if ($(window).width() < 750) {
            $(".secondaryNavigationDropdown").css("width", $(window).width());
        } else {
            $(".secondaryNavigationDropdown").css("width", "160px");
        }

        previousWidth = $(window).width()
    });

    function calculateWidth() {
        var slideCount = $('#slider ul li').length;
        var slideWidth = $('.homeSlider').width();
        var sliderUlWidth = slideCount * slideWidth;

        $('#slider').css({ width: slideWidth });
        $('#slider ul').css({ width: sliderUlWidth, marginLeft: -slideWidth });
        $('#slider ul li').css({ width: slideWidth });
        $('#slider ul li:last-child').prependTo('#slider ul');
    }

    var slideWidth = $('.homeSlider').width();
    function moveRight() {
        $('#slider ul').animate({
            left: -slideWidth
        }, 800, function () {
            $('#slider ul li:first-child').appendTo('#slider ul');
            $('#slider ul').css('left', '');
        });
    };

    $(".menu").click(function (e) {
        e.stopPropagation();

        if (!$(this).hasClass("cross")) {
            $('html, body').animate({
                scrollTop: 0
            }, 500,

                function () {
                    $(".menuIcon").addClass("cross");
                    $(".megaMenuList").addClass("showMenu");
                }
            );
        }

        $(".menuIcon").toggleClass("cross");
        $(".megaMenuList").toggleClass("showMenu");

        $(".seconaryNavigation ul li").removeClass("active");
        $(".searchIcon").removeClass("active");
        $(".headerSearchBox").slideUp("700");
        $(".headerSearchBox svg").css("display", "none");
        $(".showStatus").removeClass("active");
        $(".processStepContainer").removeClass("showStatusContainer");
    });

    $(".showStatus").on("click", function (e) {
        if (!$(this).hasClass("active")) {
            $(this).addClass("active");
        } else {
            $(this).removeClass("active");
        }

        $(".processStepContainer").toggleClass("showStatusContainer");
        e.stopPropagation();
    });

    $(".searchIcon").on("click", function (e) {
        e.stopPropagation();
        if (!$(this).hasClass("active")) {
            $(".headerSearchBox").slideDown("700").css("display", "inline-block");
            setTimeout(function () {
                $(".headerSearchBox svg").fadeIn(700);
            }, 500);
            $(this).addClass("active");
        } else {
            $(".headerSearchBox").slideUp("700");
            $(".headerSearchBox svg").fadeOut(700);
            $(this).removeClass("active");
        }
        $(".seconaryNavigation ul li").removeClass("active");
        $(".menuIcon ").removeClass("cross");
        $(".megaMenuList").removeClass("showMenu");
    });


    $(".megaMenu").on("click", "ul.menuMobile > li a", function (e) {
        e.stopPropagation();
        if ($(this).parent().hasClass("active")) {
            $(this).parent().removeClass("active");
        } else {
            if ($(this).parent().parent().hasClass("showMenu")) {
                $(this).parent().addClass("active");
            } else {
                $(this).parent().addClass("active").siblings().removeClass("active");
            }
        }
    });

    $("body").on("click touchstart", ".megaMenuContainer, .secondaryNavigationDropdown, .megaMenuList,.popup-content,.menu,.processStepContainer,.showStatus,.userPanelNavigation,.stickyNav .headerSearchBox, .attchamentContainer", function (e) {
        e.stopPropagation();
    });

    $(".megaMenu").on('click', 'ul.menuDesktop > li a', function () {
        if (!$(this).parent().hasClass("active")) {
            $(this).parent().addClass("active").siblings().removeClass("active");
        } else {
            $(this).parent().removeClass("active");
        }
    });
    //.on('mouseleave', 'ul.menuDesktop > li', function () {
    //    $(this).removeClass("active");
    //});


    $(".seconaryNavigation").on("click", "ul > li a", function (e) {
        e.stopPropagation();
        if ($(this).parent().hasClass("active")) {
            $(this).parent().removeClass("active");
        } else {
            $(this).parent().addClass("active").siblings().removeClass("active");
        }
        if ($(window).width() < 750) {
            $(".secondaryNavigationDropdown").css("width", $(window).width());
        } else {
            $(".secondaryNavigationDropdown").css("width", "160px");
        }
        $(".menuIcon ").removeClass("cross");
        $(".megaMenuList").removeClass("showMenu");
        $(".stickyNav .headerSearchBox").css('display', 'none');
        $(".stickyNav .searchIcon").removeClass("active");
    });

    $('body').on("click touchstart", function (e) {

        $("ul.megaMenuList li").each(function () {
            if ($(this).hasClass("active")) {
                $(this).removeClass("active");
            }
        });

        $(".seconaryNavigation ul li").removeClass("active");
        $(".menuIcon ").removeClass("cross");
        $(".megaMenuList").removeClass("showMenu");
        $(".showStatus").removeClass("active");
        $(".processStepContainer").removeClass("showStatusContainer");
        $(".userPanelNavigation").removeClass("showUserPanelNavigation");
        $(".attchamentContainer").css("display", "none");
        $(".stickyNav .headerSearchBox").slideUp("700");
        $(".stickyNav .headerSearchBox svg").css("display", "none");

    });
    $(".expandMore").click(function () {
        $(this).next().slideDown();
        $(this).hide();
    });

    $(".filterSearch").click(function (e) {

        if ($(this).attr('data-item') === "noFilter") {
            $('.filterSearchList').show(500);
            $("a[data-item]").attr('data-item', 'filter');
            e.preventDefault();
        }

        if ($(this).attr('data-item') === "filter") {

            $("a[data-item]").attr('data-item', 'noFilter');
            e.preventDefault();
        }
    });

    $(".linkContainer a.link").click(function () {
        if (!$(".selectedElements").children().is('div')) {
            $(".selectedElements").html("");
        }
        $(".selectedElements").append('<div class="element">' + $(this).html() + '<a class="cancel">x</a></div>');
        $(this).siblings('a').hide();
    });

    $('body').on('click', 'a.cancel', function () {
        $(this).parent().remove();
    });


    $(document).on("click", ".facetAvailable", function () {
        if ($(this).attr("data-status") === "close") {
            $(this).next().slideDown(400);
            $(this).children(".triangleRight").addClass("triangleLeft").removeClass("triangleRight");
            $(this).attr("data-status", "open");
        } else {
            $(this).next().slideUp(400);
            $(this).children(".triangleLeft").addClass("triangleRight").removeClass("triangleLeft");
            $(this).attr("data-status", "close");
        }
    });

    $(document).on("click", ".showFilter", function () {
        if ($(this).html() === "Show Filter") {
            $(".filterContainer").slideDown();
            $(".showFilter").html("Hide Filter");
            $(".filterContainer").attr("data-open", "yes");
        } else {
            $(".filterContainer").slideUp();
            $(".showFilter").html("Show Filter");
            $(".filterContainer").attr("data-open", "no");
        }
    });

    //$(document).on("click", ".clearFilter", function () {
    //    $(this).css("display", "none");
    //});

    //if ($("#commentForm").val() === "true") {
    //    $(".likeAndComment").removeClass("hide")
    //}



    //$(".likeAndComment").load("/Html/CommentForm.html");

    $(".headerSearchIcon").hover(function () {
        $(".headerSearchBox").addClass("searchActive");

        if ($("#txtSearch").val() !== "") {
            $(".headerSearchBox .searchTextClear").css("display", "inline-block");
        } else {
            $(".headerSearchBox .searchTextClear").css("display", "none");
        }
    });

    $(".headerSearchBox").on("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
    });

    $("body").on("click", function () {
        $(".headerSearchBox").removeClass("searchActive");
        $(".headerSearchBox .searchTextClear").css("display", "none");
        $(".searchIcon").removeClass("active");
    });

    $(".searchTextClear").on("click", function () {        
        $(this).siblings("input").val("");
        $(this).hide();
    });
   
    $("#txtSearchOnFacet, #txtSearch").on("keyup", function () {
        
        if ($("#txtSearchOnFacet").val() !== "") {
            $(".searchBox .searchTextClear").css("display", "inline-block");
        } else {
            $(".searchBox .searchTextClear").css("display", "none");
        }


        if ($("#txtSearch").val() !== "") {
            $(".headerSearchBox .searchTextClear").css("display", "inline-block");
        } else {
            $(".headerSearchBox .searchTextClear").css("display", "none");
        }

    });

    $("#txtPasswordNew, #txtPasswordUpdate, #Password").on("focus keyup", function () {
        var passWordStrength = [];
        $("#txtPasswordNew, #txtPasswordUpdate").removeClass("weakPassword").parent().children("div.passwordStrength").remove();

        if ($(this).val().length > 5)
            $(this).next().removeClass("hide");
        else
            $(this).next().addClass("hide");

        var upperCasePat = /^(?=.*[A-Z])([0-9A-Za-z#$%=@!{},`~&*()'<>?.:;_|^/+\t\r\n\[\]"-\\]+)$/;
        var lowerCasePat = /^(?=.*[a-z])([0-9A-Za-z#$%=@!{},`~&*()'<>?.:;_|^/+\t\r\n\[\]"-\\]+)$/;
        var numberPat = /^(?=.*[0-9])([0-9A-Za-z#$%=@!{},`~&*()'<>?.:;_|^/+\t\r\n\[\]"-\\]+)$/;
        var specialCharPat = /^(?=.*[#$%=@!{},`~&*()'<>?.:;_|^/+\t\r\n\[\]"-])([0-9A-Za-z#$%=@!{},`~&*()'<>?.:;_|^/+\t\r\n\[\]"-]+)$/;

        if (upperCasePat.test($(this).val()))
            passWordStrength.push("Uppercase");


        if (lowerCasePat.test($(this).val()))
            passWordStrength.push("Lowercase");

        if (upperCasePat.test($(this).val()) && lowerCasePat.test($(this).val())) {
            $(".charcterValidation").addClass("active");
        } else {
            $(".charcterValidation").removeClass("active");
        }

        if (numberPat.test($(this).val())) {
            passWordStrength.push("Number");
            $(".numberValidation").addClass("active");
        } else {
            $(".numberValidation").removeClass("active");
        }
        
        if ($(this).val().length >= 8) {
            $(".lengthValidation").addClass("active");
        } else {
            $(".lengthValidation").removeClass("active");
        }

        if (passWordStrength.length >= 3 || $(this).val().length >= 8) {

            $(".bar").css({ "width": "50%", "background": "#fdb66a" });
            $(".passwordStrengthText").html("Medium").css("color", "#fdb66a");
            $(".passwordStatus").html("Not Accepted").css("color", "#ff0000");
            if (passWordStrength.length == 3 && $(this).val().length >= 8) {
                $(".bar").css({ "width": "75%", "background": "#75a239" });
                $(".passwordStrengthText").html("Strong").css("color", "#75a239");
                $(".passwordStatus").html("Accepted").css("color", "#75a239");
                isPasswordStrong = true;
            }

            if (passWordStrength.length == 3 && $(this).val().length >= 8 && specialCharPat.test($(this).val())) {
                $(".bar").css({ "width": "100%", "background": "#75a239" });
                $(".passwordStrengthText").html("Very Strong").css("color", "#75a239");
                $(".passwordStatus").html("Accepted").css("color", "#75a239");
                isPasswordStrong = true;
            }

        } else {
            $(".bar").css({ "width": "25%", "background": "#ff0000" });
            $(".passwordStrengthText").html("Weak").css("color", "#ff0000");
            $(".passwordStatus").html("Not Accepted").css("color", "#ff0000");
            if ($(this).val().length !== 0)
                isPasswordStrong = false;
        }
    });

    $("#txtPasswordNew, #txtPasswordUpdate, #Password").on("blur", function () {
        $(this).next().addClass("hide");

        if (!isPasswordStrong) {
            $("#txtPasswordNew, #txtPasswordUpdate").addClass("weakPassword").parent().append("<div class='passwordStrength'>Password strength is weak.</div>");
        }
    });

    // temporary fix 

    //var urlParams = new URLSearchParams(window.location.search);
    //var myParam = urlParams.get('replaceImageUrl');

    //if (myParam == "false") myParam = false;

    //if (myParam != false) {
    //    $('img').each(function () {
    //        var $img = $(this);
    //        var imgsrc = $img.attr('src');

    //        var newSrc = imgsrc.split('/');

    //        if (newSrc[1] == 'siteassets') {
    //            newSrc[1] = "globalassets";
    //        }

    //        newSrc = newSrc.join('/');
    //        $img.attr('src', newSrc);
    //    })
    //}


});
